import './IconWidget.css'
export const IconWidget = (props) => {
    return <img src={props.Icon} className="icon-widget" />
}